import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { UnlinkedVeterinaryUser } from '../models/unlinked-veterinary-user.model';

export interface IUnlinkedVeterinaryUsersRepository {
  list(organizationId: number): Observable<readonly UnlinkedVeterinaryUser[]>;
}

export const UNLINKED_VETERINARY_USERS_REPOSITORY = new InjectionToken<IUnlinkedVeterinaryUsersRepository>('IUnlinkedVeterinaryUsersRepository');
